import { render } from "./Briefcase.vue?vue&type=template&id=5e4930dc&scoped=true"
import script from "./Briefcase.vue?vue&type=script&lang=js"
export * from "./Briefcase.vue?vue&type=script&lang=js"

import "./Briefcase.vue?vue&type=style&index=0&id=5e4930dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4930dc"]])

export default __exports__